var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 1,
    fill: "#22C55E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5345 5.00054C14.965 4.53943 15.7115 4.49393 16.2021 4.89866C16.6925 5.30346 16.7409 6.0053 16.3105 6.46651L9.05101 14.2444C8.83688 14.4738 8.53156 14.6102 8.20717 14.6218C7.88277 14.6332 7.56714 14.5193 7.33523 14.3057L3.95886 11.1936C3.49267 10.7641 3.48494 10.0613 3.9418 9.62296C4.39861 9.18471 5.14623 9.17755 5.61243 9.60692L8.0968 11.8955L14.5345 5.00054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckHealth);
export default __webpack_public_path__ + "static/media/icon-check-health.f4a68d7a8e2c15d76fc53310e848ba50.svg";
export { ForwardRef as ReactComponent };